import Loader from "@shared/components/loader";
import React from "react";

export const { ...dynamicLoadSettings } = {
  ssr: false,
  // eslint-disable-next-line react/display-name
  loading: () => <Loader />,
};
